import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { UntypedFormBuilder, UntypedFormGroup, UntypedFormArray, UntypedFormControl, Validators, } from '@angular/forms';
import axios from 'axios';

@Component({
  selector: 'app-farmer-dev-sys',
  templateUrl: './farmer-dev-sys.component.html',
  styleUrls: ['./farmer-dev-sys.component.css']
})
export class FarmerDevSysComponent implements OnInit {

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  @ViewChild(MatSort) sort: MatSort;

  // อบรม
  FormCheckandTrain: UntypedFormGroup;
  title_main: UntypedFormGroup;
  insert_datatitle: UntypedFormGroup;
  savelist = false;
  showlist = true;
  showall = true;
  Editresult;
  title;
  trainall;
  farmmerdatalist;
  selectzone = [];

  ckeckre = [
    //  {value :'', name :'-- --'},
    { value: '3', name: 'ระหว่างตรวจสอบ' },
    { value: '1', name: 'ผ่าน' },
    { value: '2', name: 'ไม่ผ่าน' },
  ]
  DataTrainallList;
  TrainallList;
  trainallListColumns: string[] = ['date_training_th', 'fmcode', 'fmname', 'title_docs', 'supzone', 'results_desc', 'comment', 'date_add_th', 'editdata', 'cancelddata'];

  constructor(private fb: UntypedFormBuilder) {

    this.FormCheckandTrain = new UntypedFormGroup({
      name: new UntypedFormControl('')
    })
    this.title_main = this.fb.group({
      title_docs: '',
      title_Des: '',
      lecturer: '',
      dt_start: '',
      dt_end: '',
      type_p: '',
      data_info: '',
      checkArray: this.fb.array([]),
    });

    this.insert_datatitle = this.fb.group({
      title_id: '',
      comment: '',
      term: '',
      fm_in: this.fb.array([]),
    });

    this.LoadtitileTrack();
    // this.LoadTraindata();
  }

  ngOnInit(): void {
    this.id_now = 0;
    this.Loadmain_topic();
    this.LoadAllFm();
    setTimeout(() => {
      this.LoadtitileTrack();
      //  this.LoadTraindata();
    }, 100);

  }
  ngAfterViewInit() {
    this.TrainallList.paginator = this.paginator;
    this.TrainallList.sort = this.sort;
  }
  resetdataGroup() {
    this.title_main.reset('');
    this.title_main.value.checkArray = [];
    //this.title_main.reset('') 
    $('input[type=checkbox]').prop('checked', false);
  }
  onCheckboxChange(e: any) {
    const checkArray: UntypedFormArray = this.title_main.get('checkArray') as UntypedFormArray;
    if (e.target.checked) {
      checkArray.push(new UntypedFormControl(e.target.value));
    } else {
      let i = 0;
      checkArray.controls.forEach((item: any) => {
        if (item.value == e.target.value) {
          checkArray.removeAt(i);
          return;
        } i++;
      });
    }
    let arr = this.title_main.value.checkArray
    this.title_main.value.checkArray = arr.filter(elm => elm).sort();
  }

  id_now = 0;
  txtSearch: string;
  // สลับแสดงผล จาก select
  Changedoc() {
    let selectdoc = this.FormCheckandTrain.get('selectdoc').value;
    // console.log(selectdoc);
    if (selectdoc == 1) { this.savelist = false; this.showlist = true; this.showall = true; }
    else if (selectdoc == 2) { this.savelist = true; this.showlist = false; this.showall = true; }
    else { this.savelist = true; this.showlist = true; this.showall = false; /*this.LoadTraindata();*/ }
  }

  // ฟิลเตอร์ข้อมูลการอบรม
  Filterby(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.TrainallList.filter = filterValue.trim().toLowerCase();;
    if (this.TrainallList.paginator) {
      this.TrainallList.paginator.firstPage();
    }
  }
  //zonelist=[];
  LoadZone() {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/zoneGroup";
    axios.get(url).then(res => {
      this.selectzone = res.data.recordset;
    })
      .catch(err => { throw err })
  }

  main_topic = [];
  sub_topic = [];
  all_topic: Array<any> = [];
  selectSub_topic = [];
  selectMain = { type: '', stype: '', m_name: '', s_name: '' };
  dataTitle_docs = [];

  Loadmain_topic() {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w?s=*&f=[CPS6263].[dbo].[knowledge]&w=[status]=1";
    axios.get(url).then(res => {
      if (res.data.rowsAffected[0] >= 1) {
        let data = res.data.recordset;
        data.sort(function (a: any, b: any) { return b.type - a.type });
        this.all_topic = data;
        this.main_topic = data.filter((el) => el.type.substr(-1, 1) == '0');
        this.sub_topic = data.filter((el) => el.type.substr(-1, 1) != '0');
      }
      //console.log('main_topic', this.main_topic); 
      //console.log('sub_topic', this.sub_topic); 
    }).catch(err => { throw (err) })
  }

  cancel_topic(id: number) {
    let msl = this.selectMain
    if (confirm('ต้องการยกเลิกรายการนี้หรือไม่?')) {
      let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/update_t_s_w?t=[CPS6263].[dbo].[knowledge]&s=[status]=3&w=[id]=" + id;
      axios.get(url).then(res => {
        if (res.data.rowsAffected[0] >= 1) {
          this.Loadmain_topic();
          setTimeout(() => {
            this.SubTypeSelectS(msl.stype, msl.m_name);
          }, 500);
        }
      }).catch(err => { throw (err) })
    }
  }

  SubTypeSelectS(type = '', name = '') {
    let t0 = type.substring(0, 1);
    this.selectMain.m_name = name;
    this.selectMain.type = t0;
    this.selectMain.stype = type;
    this.selectSub_topic = this.sub_topic.filter((el) => el.type == t0);
    //console.log('selectMain :',this.selectMain);
    //console.log('selectSub_topic :',this.selectSub_topic);
  }
  saveMain_topic() {
    let msl = this.selectMain
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/insert_t_c_v?t=[CPS6263].[dbo].[knowledge]&c=[type],[name]&v='" + msl.type + "','" + msl.s_name + "'";
    axios.get(url).then(res => {
      if (res.data.rowsAffected[0] >= 1) {
        this.Loadmain_topic();
        alert("บันทึกข้อมูลสำเร็จ ");
        setTimeout(() => {
          this.SubTypeSelectS(msl.stype, msl.m_name);
        }, 100);
      }
      //console.log('sub_topic', this.sub_topic); 
      //console.log('saveMain_topic',msl)
    }).catch(err => { throw (err) })
  }

  dataAr = [];
  getdata(FMCODE = '', fmname = '', tid = 0) {
    this.dataAr = this.dataAr.filter(el => el.FMCODE != FMCODE);
    let datain = { 'FMCODE': FMCODE, 'fmname': fmname, 'tid': tid };
    this.dataAr.push(datain);
    this.dataAr = this.dataAr.filter((v, i, a) => a.findIndex(t => (t.FMCODE === v.FMCODE)) === i);
    console.log('dataAr', this.dataAr);
  }

  deletesomevalue(FMCODE = '') {
    let data = this.dataAr.filter(el => el.FMCODE != FMCODE);
    this.dataAr = data.sort(function (a, b) {
      return a.FMCODE - b.FMCODE;
    });
  }

  SavedataTrainGroup() {
    let arr = this.title_main.value;
    //console.log('dataTitle_docs',arr);
    let title_docs: string = arr.title_docs;
    let title_Des: string = arr.title_Des;
    let lecturer: string = arr.lecturer;
    let dt_start: string = this.date2Local(arr.dt_start);
    let dt_end: string = this.date2Local(arr.dt_end);
    let data_info: string = arr.data_info;
    let type_p: string = arr.type_p;
    let inarr = arr.checkArray;
    inarr = inarr.filter(elm => elm);
    console.log('alldata', title_docs, title_Des, lecturer, dt_start, dt_end, data_info, type_p, inarr);

    //console.log('inarr',inarr);

    if (title_docs != '' && title_Des != '' && data_info != '' && type_p != '') { alert('กรุณากรอกข้อมูลให้ครบทุกช่อง^^'); }
    else {
      if (confirm('ต้องการบันทึกข้อมูลหรือไม่?')) {
        let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/insert_t_c_v?t=[CPS6263].[dbo].[PR_TitleTrack]&c=[title_docs],[title_Description],[lecturer],[dt_start],[dt_end],[type_p],[data_info]&v='"
          + title_docs + "','" + title_Des + "','" + lecturer + "','" + dt_start + "','" + dt_end + "','" + type_p + "','" + inarr + "'";
        console.log('url', url);
        axios.post(url).then(res => {
          if (res.data.code) { alert("บันทึกข้อมูลไม่สำเร็จ"); }
          if (res.data.rowsAffected) {
            alert("บันทึกข้อมูลเรียบร้อย");
            this.LoadtitileTrack();
            $('input[type="text"]').val(''); $('textarea').val('');
            this.resetdataGroup();
          }
        }).catch(err => { console.log(err) })
      } else {
        console.log('no update');
      }
    }
  }
  AlldataFm = [];
  LoadAllFm() {
    let url = 'https://asia-southeast2-brr-farmluck.cloudfunctions.net/api_tast2/select_s_f_w?s=FMCODE_B1 FMCODE,fmname,SUPZONE&f=CPS6263.dbo.t_farmer&w=area0=1';
    axios.get(url).then(res => {
      if (res.data.length >= 1) {
        this.AlldataFm = (res.data);
      }
      else {
        alert("ไม่สามารถโหลด " + 'ข้อมูลชาวไร่ได้' + " ได้");
      }
    }).catch(err => { throw (err) })
  }

  // โหลดข้อมูล หัวข้อ 
  LoadtitileTrack() {
    let url = 'https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/selectPR_TitleTrack';
    fetch(url).then(res => res.json()).then((out: any) => {
      this.title = out.recordsets[0];
    })
      .catch(err => { throw err });
  }
  /*
    LoadTraindata(){
      let url2 = 'https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/selectPR_dataTitleTrack';
      axios.get(url2).then(response => {
        let data =  response.data.recordsets[0];
        this.TrainallList = new MatTableDataSource(data);
      })
      .catch(err => {
        console.error(err)
      })
    }*/

  setaddfm = false;
  SubTraindata = [];
  title_Desc = [];
  LoadSubTraindata(subt: number) {
    //this.title_Desc = this.title[0].title_Description;
    this.title_Desc = this.title.filter((el) => el.title_id == subt);
    console.log('title_Desc', this.title_Desc[0]);
    let url = 'https://asia-southeast2-brr-farmluck.cloudfunctions.net/api_tast2/select_s_f_w?s=*&f=CPS6263.dbo.[v_PR_dataTitleTrack]&w=title_id=' + subt;
    axios.get(url).then(res => {
      if (res.data.length >= 1) {
        this.SubTraindata = (res.data).sort((a, b) => {
          return new Date(b.date_update).getTime() - new Date(a.date_update).getTime();
        });
        //console.log('data',data);
      }
      else {
        this.SubTraindata = [];
        //alert("ไม่สามารถโหลด "+'ข้อมูลชาวไร่ได้'+" ได้");
      }
    }).catch(err => { throw (err) })
  }

  // บันทึกข้อมูลหัวข้อ
  SaveCheckandTrainGroup() {
    let title_doc = this.FormCheckandTrain.get('title_doc').value;
    let title_dec = this.FormCheckandTrain.get('title_dec').value;

    if (title_doc == null || title_dec == null || title_doc == '' || title_dec == '') { alert('กรุณากรอกข้อมูลให้ครบทุกช่อง^^'); }
    else {
      if (confirm('ต้องการบันทึกข้อมูลหรือไม่?')) {
        let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/insertPR_TitleTrack?title_docs='" + title_doc + "'" + "&title_Description='" + title_dec + "'";
        axios.post(url).then(res => {
          if (res.data.code) { alert("บันทึกข้อมูลไม่สำเร็จ"); }
          if (res.data.rowsAffected) { alert("บันทึกข้อมูลเรียบร้อย"); }
        }).catch(err => { console.log(err) })

        this.LoadtitileTrack();
        $('input[type="text"]').val('');
        $('textarea').val('');
      }
      else {
        console.log('no update');
      }
    }
  }
  // บันทึกข้อมูลผลอบรม
  SaveTrainS() {
    let x = 0, y = 0;
    let lenAr = this.dataAr.length;
    let sid = this.insert_datatitle.value.title_id;
    let comment = this.insert_datatitle.value.comment;
    if (lenAr > 0) {
      if (confirm('ต้องการบันทึกข้อมูล ' + lenAr + ' รายการ หรือไม่?')) {
        for (let i = 0; i < lenAr; i++) {
          let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/add_PR_dataTitle?[title_id]=" + sid + "&[fmcode]=" + this.dataAr[i].FMCODE + "&[results]=" + this.dataAr[i].tid + "&[comment]=" + comment + "&[status]=1";
          axios.post(url).then(res => {
            if (res.data.rowsAffected[0] == 1) y++
            else x++
          }).catch(err => { console.log(err) })
        }
        alert("สำเร็จ:" + y + " ไม่สำเร็จ:" + x);
        console.log('สำเร็จ', y, 'ไม่สำเร็จ', x)
      }
    }

    this.dataAr = [];
    this.insert_datatitle.value.comment = '';
    this.LoadSubTraindata(sid);
    /*
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/add_PR_dataTitle?[title_id]=36&[fmcode]=0000034019&[comment]=ทดสอบ&[status]=3";
    axios.post(url).then(res => {
      if(res.data.code){alert("บันทึกข้อมูลไม่สำเร็จ");}
      if(res.data.rowsAffected){alert("บันทึกข้อมูลเรียบร้อย");}
    }).catch(err => {console.log(err)})      
      this.LoadTraindata(); 
    */
  }

  // ยกเลิกรายการ
  CancleTrain(id) {
    let sid = this.insert_datatitle.value.title_id;
    if (confirm('ต้องการยกเลิกรายการหรือไม่?')) {
      let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/canceled_dataTitleTrack?pr_id=" + id;
      axios.post(url).then(res => {
        if (res.data.rowsAffected) { alert('ยกเลิกรายการเรียบร้อย ^_^!'); }
        if (res.data.code) { alert("ยกเลิกรายการไม่สำเร็จ"); }
      }).catch(err => { console.log(err); })
      this.LoadSubTraindata(sid);
    }
    else {
      console.log('no update');
    }
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.Editresult = null;
    this.title = null;
    this.trainall = null;
    this.farmmerdatalist = null;
    this.DataTrainallList = null;
    this.TrainallList = null;
  }
  THtoLocalstring(date_i: string) {
    if (!date_i) { return ''; }
    const date1 = new Date(date_i);
    let options: any = {
      year: "numeric", month: "short", day: "2-digit", hour: "2-digit", minute: "2-digit", timeZone: 'UTC',
    };
    return date1.toLocaleString('th-TH', options);
  }

  date2Local(date_i: string) {
    if (!date_i) { return ''; }
    let objectDate = new Date(date_i);
    let day = (objectDate.getDate()).toString();
    let month = (objectDate.getMonth() + 1).toString();
    let year = (objectDate.getFullYear()).toString();
    return year + "-" + month + "-" + day;
  }

}
